module.exports = __webpack_public_path__ + "img/Pedro.fc037b79.png";